<template>
  <v-container fluid>
    <v-card class="pb-2">
      <new-order-alert
          v-if="showOrderAlert"
          :lot-type="LOT_TYPES.REQUEST_OFFERS"
          :order="order"
          :index="1"
          :timeout="10000000000000" />
      <v-toolbar :dark="$vuetify.theme.dark" color="primary">
        <v-row>
          <v-col cols="6" align-self="center" class="text-left">
            <v-toolbar-title class="textwithbackground--text">
              {{ $t('Настройки темы') }}
            </v-toolbar-title>
          </v-col>
          <v-col cols="6" class="text-right">
            <btn-icon-tip
                v-if="hasChanges"
                x-large
                icon="undo"
                icon-color="secondaryiconbtn"
                :tip="$t('Отменить локальные изменения')"
                :disabled="isLoading"
                @click="reply" />
            <btn-icon-tip
                v-if="!isDefault"
                x-large
                icon="restart_alt"
                icon-color="secondaryiconbtn"
                :tip="$t('Сбросить на настройки по умолчанию')"
                :disabled="isLoading"
                @click="openResetToDefaultThemeDialog" />
            <btn-icon-tip
                v-if="temp[themeType]"
                x-large
                icon="visibility_off"
                icon-color="secondaryiconbtn"
                :tip="$t('Отключить предпросмотр')"
                :disabled="isLoading"
                @click="previewOff" />
            <btn-icon-tip
                v-if="!temp[themeType]"
                x-large
                icon="visibility"
                icon-color="secondaryiconbtn"
                :tip="$t('Предпросмотр')"
                :disabled="isLoading || !hasChanges"
                @click="preview" />
            <btn-icon-tip
                icon="save"
                x-large
                icon-color="secondaryiconbtn"
                :tip="$t('Сохранить')"
                :disabled="isLoading || !hasChanges"
                @click="editClientTheme" />
          </v-col>
        </v-row>
      </v-toolbar>
      <v-row v-if="!!generalError || isLoading" class="my-0 py-0 mx-1">
        <v-col cols="12">
          <v-progress-linear :active="isLoading" color="loader" indeterminate />
        </v-col>
        <v-col cols="12" class="mx-1">
          <general-error v-if="!!generalError" />
        </v-col>
      </v-row>
      <!-- <v-row v-if="isMainAdmin" class="text-left pa-2 ma-2">
        <v-col cols="12">
          <v-switch
              v-model="darkTheme"
              hint="Переключатель глобального состояния темы"
              inset
              label="Темная тема"
              persistent-hint />
        </v-col>
      </v-row> -->
      <ValidationObserver ref="settings">
        <v-row justify="center" class="text-left pa-2 ma-2 blue-grey lighten-5">
          <v-col cols="12">
            <v-data-table
                :headers="headers"
                :items="settings"
                :items-per-page="itemsPerPage"
                item-key="propertyName"
                dense
                :loading="isLoading"
                :locale="systemLocale">
              <template v-slot:progress>
                <v-progress-linear :active="isLoading" color="loader" indeterminate />
              </template>
              <!-- eslint-disable-next-line vue/valid-v-slot -->
              <template v-slot:item.theme="{ item }">
                <icon-tip
                    :icon="isDark(item) ? 'dark_mode' : 'light_mode'"
                    icon-color="blue-grey"
                    :tip="$t(isDark(item) ? 'Темная' : 'Светлая')" />
              </template>
              <!-- eslint-disable-next-line vue/valid-v-slot -->
              <template v-slot:item.description="{ item }">
                <v-icon
                    small
                    left
                    color="requiredfield">
                  *
                </v-icon>
                {{ item.description }}
              </template>
              <!-- eslint-disable-next-line vue/valid-v-slot -->
              <template v-slot:item.value="{ item }">
                <v-icon :color="item.value">
                  circle
                </v-icon>
                {{ item.value }}
              </template>
              <!-- eslint-disable-next-line vue/valid-v-slot -->
              <template v-slot:item.propertyName="{ item }">
                <validatable-color-picker
                    :key="item.propertyName"
                    v-model="item.value"
                    :readonly="isLoading"
                    :rules="{ required: item.required }"
                    :label="$t(item.description)" />
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </ValidationObserver>

      <v-row v-if="!!generalError || isLoading" class="my-0 py-0 mx-1">
        <v-col cols="12">
          <v-progress-linear :active="isLoading" color="loader" indeterminate />
        </v-col>
        <v-col cols="12" class="mx-1">
          <general-error v-if="!!generalError" />
        </v-col>
      </v-row>
      <v-row class="px-2 pt-2">
        <v-col>
          <v-expansion-panels>
            <v-expansion-panel v-test="{ panel: '' }">
              <v-expansion-panel-header>
                <div id="exemples">
                  <v-icon>
                    preview
                  </v-icon>
                  {{ $t('Примеры') }}
                  <!-- <v-row>
                    <v-col cols="6" class="text-right"> -->
                  <btn-icon-tip
                      v-if="hasChanges"
                      x-large
                      icon="undo"
                      icon-color="primaryiconbtn"
                      :tip="$t('Отменить локальные изменения')"
                      :disabled="isLoading"
                      @click="reply" />
                  <btn-icon-tip
                      v-if="!isDefault"
                      x-large
                      icon="restart_alt"
                      icon-color="primaryiconbtn"
                      :tip="$t('Сбросить на настройки по умолчанию')"
                      :disabled="isLoading"
                      @click="openResetToDefaultThemeDialog" />
                  <btn-icon-tip
                      v-if="temp[themeType]"
                      x-large
                      icon="visibility_off"
                      icon-color="primaryiconbtn"
                      :tip="$t('Отключить предпросмотр')"
                      :disabled="isLoading"
                      @click="previewOff" />
                  <btn-icon-tip
                      v-if="!temp[themeType]"
                      x-large
                      icon="visibility"
                      icon-color="primaryiconbtn"
                      :tip="$t('Предпросмотр')"
                      :disabled="isLoading || !hasChanges"
                      @click="preview" />
                  <btn-icon-tip
                      icon="save"
                      x-large
                      icon-color="primaryiconbtn"
                      :tip="$t('Сохранить')"
                      :disabled="isLoading || !hasChanges"
                      @click="editClientTheme" />
                  <!-- </v-col>
                  </v-row> -->
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content eager>
                <v-row>
                  <v-col class="text-center" align-self="center">
                    <btn-icon-tip
                        id="previewBtn1"
                        ref="previewBtn1"
                        icon="preview"
                        icon-color="warning"
                        :tip="$t('Открыть диалоговое окно для предупреждения')"
                        @click="openConfirmDialog(true)" />
                    <btn-icon-tip
                        id="previewBtn2"
                        ref="previewBtn2"
                        icon="preview"
                        icon-color="primary"
                        :tip="$t('Открыть информационное диалоговое окно')"
                        @click="openConfirmDialog(false)" />
                    <btn-icon-tip
                        id="previewBtn3"
                        ref="previewBtn3"
                        :icon="needReloadPage
                          ? 'visibility_off'
                          : 'preview'"
                        icon-color="error"
                        :tip="$t(needReloadPage
                          ? 'Отключить предпросмотр'
                          : 'Окно уведомления об изменении версии проекта')"
                        @click="setNeedReloadPageAction(!needReloadPage)" />
                    <btn-icon-tip
                        id="previewBtn4"
                        ref="previewBtn4"
                        :icon="showOrderAlert
                          ? 'visibility_off'
                          : 'preview'"
                        icon-color="primaryiconbtn"
                        :tip="$t(showOrderAlert
                          ? 'Отключить предпросмотр'
                          : 'Окно оповещения о новом ценовом предложении')"
                        @click="showOrderAlert = !showOrderAlert" />
                    <confirm-dialog
                        v-if="confirmDialog.show"
                        :dialog-prop="confirmDialog"
                        @close="closeDialog('confirmDialog')" />
                  </v-col>
                </v-row>
                <v-row class="my-0 py-0 mx-1">
                  <v-col cols="12">
                    <v-progress-linear :active="true" color="loader" indeterminate />
                  </v-col>
                  <v-col cols="12" class="mx-1">
                    <v-progress-circular color="loader" indeterminate size="50" width="7" />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <v-alert
                        :dark="$vuetify.theme.dark"
                        class="text-center ma-1"
                        outlined
                        :value="true"
                        type="success">
                      {{ $t('Сообщение отправлено') }}
                    </v-alert>
                  </v-col>
                  <v-col cols="6">
                    <v-alert
                        :dark="$vuetify.theme.dark"
                        class="text-center ma-1"
                        outlined
                        :value="true"
                        type="error">
                      {{ $t('Сообщение с ошибкой') }}
                    </v-alert>
                  </v-col>
                  <v-col cols="6">
                    <v-alert
                        :dark="$vuetify.theme.dark"
                        class="text-center ma-1"
                        outlined
                        :value="true"
                        type="info">
                      {{ $t('Информационное сообщение') }}
                    </v-alert>
                  </v-col>
                  <v-col cols="6">
                    <v-alert
                        :dark="$vuetify.theme.dark"
                        class="text-center ma-1"
                        outlined
                        :value="true"
                        type="warning">
                      {{ $t('Предупреждение') }}
                    </v-alert>
                  </v-col>
                  <v-col cols="6">
                    <v-alert
                        :dark="$vuetify.theme.dark"
                        class="text-center ma-1"
                        :value="true"
                        type="success">
                      {{ $t('Сообщение отправлено') }}
                    </v-alert>
                  </v-col>
                  <v-col cols="6">
                    <v-alert
                        :dark="$vuetify.theme.dark"
                        class="text-center ma-1"
                        :value="true"
                        type="error">
                      {{ $t('Сообщение с ошибкой') }}
                    </v-alert>
                  </v-col>
                  <v-col cols="6">
                    <v-alert
                        :dark="$vuetify.theme.dark"
                        class="text-center ma-1"
                        :value="true"
                        type="info">
                      {{ $t('Информационное сообщение') }}
                    </v-alert>
                  </v-col>
                  <v-col cols="6">
                    <v-alert
                        :dark="$vuetify.theme.dark"
                        :light="!$vuetify.theme.dark"
                        class="text-center ma-1"
                        :value="true"
                        type="warning">
                      {{ $t('Предупреждение') }}
                    </v-alert>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <custom-stepper
                        v-model="stepNumber"
                        :steps-param-array="stepsProperties"
                        :loading="isLoading"
                        :disabled-forward-btn="isLoading"
                        :success="success">
                      <template v-slot:main-1>
                        <v-card class="pa-4">
                          <ValidationObserver ref="wizard">
                            <v-row>
                              <v-col
                                  class="pl-2"
                                  cols="12"
                                  md="6">
                                <validatable-enum-combobox
                                    v-model="params.status"
                                    v-test="{ combobox: 'status' }"
                                    dense
                                    clearable
                                    rules="required"
                                    :values-enum="STATUS_ENUM"
                                    :label="$t('Статус документа')" />
                              </v-col>
                              <v-col
                                  class="pl-2"
                                  cols="12"
                                  md="6">
                                <v-text-field
                                    v-model="params.userName"
                                    v-test="{ input: 'userName' }"
                                    dense
                                    clearable
                                    :label="$t('Имя пользователя')" />
                              </v-col>
                              <v-col
                                  class="pl-2"
                                  cols="12"
                                  md="6">
                                <validatable-text-input
                                    v-model="params.contactPerson"
                                    v-test="{ input: 'contactPerson' }"
                                    dense
                                    clearable
                                    :label="$t('Контактное лицо')"
                                    rules="required" />
                              </v-col>
                              <v-col
                                  class="pl-2"
                                  cols="12"
                                  md="6">
                                <validatable-date-picker
                                    v-model="params.dateEnd"
                                    v-test="{ date: 'dateEnd' }"
                                    dense
                                    :label="$t('Дата завершения')"
                                    rules="required" />
                              </v-col>
                            </v-row>
                          </ValidationObserver>
                        </v-card>
                      </template>
                      <template v-slot:main-2>
                        <v-card class="pa-4">
                          <v-row>
                            <text-view
                                cols="12"
                                md="6"
                                multiline
                                icon="fiber_manual_record"
                                :icon-color="params.status === DOCUMENT_STATUSES.INPROCESS
                                  ? 'info'
                                  : (params.status === DOCUMENT_STATUSES.APPROVED)
                                    ? 'success'
                                    : 'error'"
                                :label="$t('Статус документа')"
                                :display="$t(params.status ? STATUS_ENUM[params.status] : '')" />
                            <text-view
                                cols="12"
                                md="6"
                                multiline
                                icon="people"
                                :label="$t('Имя пользователя')"
                                :display="params.userName" />
                            <text-view
                                cols="12"
                                md="6"
                                multiline
                                icon="people"
                                :label="$t('Контактное лицо')"
                                :display="params.contactPerson" />
                            <date-view
                                cols="12"
                                md="6"
                                multiline
                                icon="event"
                                :label="$t('Дата завершения')"
                                :display="params.dateEnd" />
                          </v-row>
                        </v-card>
                      </template>
                      <template v-slot:buttons-2>
                        <v-btn
                            id="sendBtn"
                            color="primary"
                            :disabled="isLoading"
                            @click="setSuccess">
                          {{ $t('Отправить') }}
                        </v-btn>
                      </template>
                    </custom-stepper>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>

  import BtnIconTip from '@/components/reused/ui/BtnIconTip.vue'
  import IconTip from '@/components/reused/ui/IconTip.vue'
  import ValidatableColorPicker from '@/components/reused/ui/ValidatableColorPicker.vue'
  import ValidatableTextInput from '@/components/reused/ui/ValidatableTextInput.vue'
  import ValidatableDatePicker from '@/components/reused/ui/ValidatableDatePicker.vue'
  import ValidatableEnumCombobox from '@/components/reused/ui/ValidatableEnumCombobox.vue'
  import CustomStepper from '@/components/reused/ui/CustomStepper.vue'
  import TextView from '@/components/reused/ui/TextView.vue'
  import DateView from '@/components/reused/ui/DateView.vue'
  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import ConfirmDialog from '@/components/reused/common/ConfirmDialog.vue'
  import NewOrderAlert from '@/components/reused/orders/NewOrderAlert.vue'
  import { mapActions, mapState } from 'vuex'
  import { SYSTEM_SETTINGS, RELEVANCE } from '@/constants/store.js'
  import { THEME_TYPES, DOCUMENT_STATUSES, LOT_TYPES } from '@/constants/business'
  import { STATUS_ENUM } from '@/constants/enums'

  export default {
    components: {
      GeneralError,
      BtnIconTip,
      IconTip,
      ValidatableColorPicker,
      ValidatableTextInput,
      ValidatableDatePicker,
      ValidatableEnumCombobox,
      ConfirmDialog,
      NewOrderAlert,
      TextView,
      DateView,
      CustomStepper
    },
    data () {
      return {
        STATUS_ENUM,
        DOCUMENT_STATUSES,
        LOT_TYPES,
        isLoading: false,
        itemsPerPage: -1,
        darkTheme: false,
        success: false,
        stepNumber: 1,
        temp: {
          [THEME_TYPES.LIGHT]: null,
          [THEME_TYPES.DARK]: null,
          isDark: false
        },
        settings: [],
        params: {
          dateEnd: null,
          status: null,
          userName: null,
          contactPerson: null
        },
        confirmDialog: {
          show: false,
          additional: null,
          text: null,
          callback: null,
          warning: true
        },
        showOrderAlert: false,
        order: {
          // orderId: '50010258-e986-4fda-9c6d-d2d70c3963df',
          // userId: 'c14d3788-fb6a-45ea-8261-ec45cc24a8fe',
          // sessionId: '248e6215-989e-4bcf-a143-4f9f83925b60',
          orderDate: '2022-09-01T12:15:34.074634',
          // isOwner: true,
          // isActive: true,
          premiums: [
            {
              positionNumber: 1,
              positionDescription: '1',
              positionId: '384552ff-be0a-4fc9-b21e-4cf8eb1700be',
              premium: 3.12
            }
          ]
        }
      }
    },
    computed: {
      ...mapState(RELEVANCE.NAMESPACE, {
        needReloadPage: RELEVANCE.STATE.NEED_RELOAD_PAGE
      }),
      headers () {
        let headers = [
          { text: this.$t('Тема'), align: 'start', sortable: false, value: 'theme' },
          { text: this.$t('Описание параметра'), align: 'start', sortable: false, value: 'description' },
          { text: this.$t('Цвет'), align: 'start', sortable: false, value: 'value' },
          { text: this.$t('Действия'), align: 'center', sortable: false, value: 'propertyName' }
        ]
        if (!this.isMainAdmin) {
          headers = headers.filter(h => h.value !== 'theme')
        }
        return headers
      },
      themeProps () {
        const props = this.configuration.themeProps || []
        return props.filter(p => p.theme === this.themeType)
      },
      themeType () {
        return this.darkTheme
          ? THEME_TYPES.DARK
          : THEME_TYPES.LIGHT
      },
      hasChanges () {
        const vm = this
        return vm.settings.some(prop => {
          return !vm.themeProps.some(p => {
            // if (prop.propertyName === p.propertyName) {
            //   console.log(prop.propertyName + '-' + p.propertyName)
            //   console.log(prop.value + '-' + p.value)
            // }

            return p.propertyName === prop.propertyName && p.value === prop.value
          })
        })
      },
      isDefault () {
        const vm = this
        const props = this.configuration.themeProps || []
        const defaultProps = props.filter(p => p.theme === THEME_TYPES.DARK)
        return defaultProps.every(prop => {
          return vm.themeProps.some(p => {
            return p.propertyName === prop.propertyName && p.value === prop.value
          })
        })
      },
      stepsProperties () {
        return [
          {
            stepNumber: 1,
            stepTitle: this.$t('Добавление информации'),
            stepTip: this.$t('Текст информационного характера.'),
            successText: this.$t('Успешная операция.'),
            toNextStep: this.toNextStep,
            toPrevStep: null,
            cancel: () => {}
          },
          {
            stepNumber: 2,
            stepTitle: this.$t('Завершающий шаг'),
            stepTip: '',
            successText: this.$t('Успешная операция.'),
            toNextStep: null,
            toPrevStep: this.toPrevStep,
            cancel: () => {}
          }
        ]
      }
    },
    watch: {
      themeProps: {
        deep: true,
        immediate: true,
        handler (newVal) {
          if (newVal && newVal.length) {
            this.settings = newVal.map(p => ({ ...p }))
          }
        }
      },
      hasChanges (newVal, oldVal) {
        if (newVal) {
          this.previewOff()
        }
      },
      darkTheme (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.previewOff()
        }
      }
    },
    created () {
      Promise.all([
      ])
    },
    methods: {
      ...mapActions(RELEVANCE.NAMESPACE, {
        setNeedReloadPageAction: RELEVANCE.ACTIONS.SET_NEED_RELOAD_PAGE
      }),
      ...mapActions(SYSTEM_SETTINGS.NAMESPACE, {
        editClientThemeAction: SYSTEM_SETTINGS.ACTIONS.EDIT_CLIENT_THEME,
        resetToDefaultThemeAction: SYSTEM_SETTINGS.ACTIONS.RESET_TO_DEFAULT_THEME
      }),
      isDark: function (item) {
        return item.theme === THEME_TYPES.DARK
      },
      preview: function () {
        const prevVal = this.$vuetify.theme.themes[this.themeType]
        this.temp[this.themeType] = { ...prevVal }
        this.temp.isDark = this.$vuetify.theme.dark
        this.settings.forEach(prop => {
          // console.log(prop.propertyName)
          // console.log(this.$vuetify.theme.themes[this.themeType][prop.propertyName] + '-' + prop.value)
          this.$vuetify.theme.themes[this.themeType][prop.propertyName] = prop.value
        })
        this.$vuetify.theme.dark = this.darkTheme
      },
      previewOff: function () {
        if (this.temp[this.themeType]) {
          for (const prop in this.temp[this.themeType]) {
            this.$vuetify.theme.themes[this.themeType][prop] = this.temp[this.themeType][prop]
          }
          this.temp[this.themeType] = null
          this.$vuetify.theme.dark = this.temp.isDark
        }
      },
      reply: function () {
        this.settings = this.themeProps.map(p => ({ ...p }))
        this.previewOff()
      },
      editClientTheme: async function () {
        const result = await this.$refs.settings.validate()
        if (!result) {
          return
        }
        try {
          const model = {
            themeType: this.themeType,
            props: this.settings.map(s => ({
              propertyName: s.propertyName,
              value: s.value
            }))
          }
          this.isLoading = true
          await this.editClientThemeAction(model)
          await this.getConfiguration()
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        } finally {
          this.isLoading = false
        }
      },
      resetToDefaultTheme: async function () {
        try {
          this.isLoading = true
          await this.resetToDefaultThemeAction()
          await this.getConfiguration()
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        } finally {
          this.isLoading = false
        }
      },
      openConfirmDialog: function (warning) {
        this.confirmDialog.text = this.$t(warning ? 'Повышенное внимание к сообщению' : 'Информационное сообщение')
        this.confirmDialog.callback = this.sendToCRM
        this.confirmDialog.warning = warning
        this.confirmDialog.show = true
      },
      openResetToDefaultThemeDialog: function () {
        this.confirmDialog.text = this.$t('Цветовая тема будет сброшена до настроек по умолчанию. Продолжить?')
        this.confirmDialog.callback = this.resetToDefaultTheme
        this.confirmDialog.warning = true
        this.confirmDialog.show = true
      },
      toNextStep: async function (step) {
        const result = await this.$refs.wizard.validate()
        if (result) {
          this.success = false
          this.stepNumber = step + 1
        }
      },
      toPrevStep: function (step) {
        this.success = false
        this.stepNumber = step - 1
      },
      setSuccess: function () {
        this.success = true
      }
    }
  }
</script>
